(function($){
$(document).ready(function() {


}); // document.ready
})(jQuery);
